import React from 'react';
import UpdateChqRcpt from './Update_Chq_Rcpt';
import '../../../CommonCSS/SocietyCSS.css'

const UpdChqRcptApp = () => {
  return (
    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Update Cheque Receipts</h5>
          </div>  
        </div>
        <UpdateChqRcpt/>
      </div>
    </div >
  );
};

export default UpdChqRcptApp;
